import { svgPaths, facilitySvgPaths, menuSvgPaths, parkingSvgPaths, LogoContainer, EventContainer, MainContainer } from '../../imports/svgPaths';
import { useState } from 'react';
import { facilityData } from '../../constants/facilityData';
// import.*from.*imports/svg-8txpwpskyh";

// Facility Section Title
function Container2() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-10 items-start justify-start leading-[0] not-italic p-0 relative shrink-0 text-nowrap"
      data-name="Container"
    >
      <div className="font-paperlogy font-bold relative shrink-0 text-[0px] text-left text-neutral-950 tracking-[-0.96px]">
        <p className="leading-[normal] text-[32px] sm:text-[40px] lg:text-[48px] text-wrap sm:text-nowrap whitespace-normal sm:whitespace-pre">
          <span className="font-paperlogy font-medium">{`안전하고 즐거운 `}</span>
          <span className="font-paperlogy font-extrabold font-bold">
            놀이시설
          </span>
          <span className="adjustLetterSpacing font-paperlogy font-medium">
            을 안내드려요
          </span>
        </p>
      </div>
      <div className="font-paperlogy font-normal leading-[normal] relative shrink-0 text-[#333333] text-[16px] sm:text-[18px] lg:text-[20px] text-left tracking-[-0.4px] whitespace-normal sm:whitespace-pre">
        <p className="adjustLetterSpacing block mb-0">
          즐거운 XR콘텐츠, 놀이 시설에서 놀다가
        </p>
        <p className="adjustLetterSpacing block">휴식공간에서 쉴 수 있어요</p>
      </div>
    </div>
  );
}

// Facility Tab Buttons
function ButtonContainer1({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`box-border content-stretch flex flex-row gap-2.5 h-11 items-center justify-center px-4 py-3 relative rounded-[100px] shrink-0 cursor-pointer transition-all duration-200 ${
        isActive 
          ? 'bg-[#333333] text-[#ffffff]' 
          : 'border border-[#cccccc] text-[#333333] hover:bg-gray-50 hover:border-[#aaaaaa]'
      }`}
      data-name="Button Container"
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center text-nowrap tracking-[-0.32px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          디지털콘텐츠
        </p>
      </div>
    </button>
  );
}

function ButtonContainer2({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`box-border content-stretch flex flex-row gap-2.5 h-11 items-center justify-center px-4 py-3 relative rounded-[100px] shrink-0 cursor-pointer transition-all duration-200 ${
        isActive 
          ? 'bg-[#333333] text-[#ffffff]' 
          : 'border border-[#cccccc] text-[#333333] hover:bg-gray-50 hover:border-[#aaaaaa]'
      }`}
      data-name="Button Container"
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center text-nowrap tracking-[-0.32px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          놀이시설
        </p>
      </div>
    </button>
  );
}

function ButtonContainer3({ isActive, onClick }: { isActive: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`box-border content-stretch flex flex-row gap-2.5 h-11 items-center justify-center px-4 py-3 relative rounded-[100px] shrink-0 cursor-pointer transition-all duration-200 ${
        isActive 
          ? 'bg-[#333333] text-[#ffffff]' 
          : 'border border-[#cccccc] text-[#333333] hover:bg-gray-50 hover:border-[#aaaaaa]'
      }`}
      data-name="Button Container"
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[16px] text-center text-nowrap tracking-[-0.32px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          부대시설
        </p>
      </div>
    </button>
  );
}

function Container3({ activeTab, onTabChange }: { activeTab: string; onTabChange: (tab: string) => void }) {
  return (
    <div
      className="box-border content-stretch flex flex-row gap-2 items-start justify-start opacity-80 p-0 relative shrink-0"
      data-name="Container"
    >
      <ButtonContainer1 isActive={activeTab === 'digital'} onClick={() => onTabChange('digital')} />
      <ButtonContainer2 isActive={activeTab === 'physical'} onClick={() => onTabChange('physical')} />
      <ButtonContainer3 isActive={activeTab === 'facilities'} onClick={() => onTabChange('facilities')} />
    </div>
  );
}

function Container4({ activeTab, onTabChange }: { activeTab: string; onTabChange: (tab: string) => void }) {
  return (
    <div
      className="box-border content-stretch flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 lg:gap-0 p-0 relative shrink-0 w-full px-[max(20px,_calc((100vw_-_1280px)_/_2))]"
      data-name="Container"
    >
      <div className="w-[min(1280px,_calc(100vw_-_40px))] mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 lg:gap-0">
        <Container2 />
        <Container3 activeTab={activeTab} onTabChange={onTabChange} />
      </div>
    </div>
  );
}

// Facility Image Container - facilityData 인터페이스와 일치하도록 업데이트
function Container5({ 
  facilityItem,
  currentIndex,
  totalImages,
  onImageSelect,
  onPrevImage,
  onNextImage
}: { 
  facilityItem: {
    id: string;
    title: string;
    description: string;
    category: 'physical' | 'digital' | 'facilities' | 'all';
    image: string;
    features?: string[];
  };
  currentIndex: number;
  totalImages: number;
  onImageSelect: (index: number) => void;
  onPrevImage: () => void;
  onNextImage: () => void;
}) {
  return (
    <div
      className="w-full h-[450px] min-h-[450px] sm:h-[500px] sm:min-h-[500px] md:h-[540px] md:min-h-[540px] lg:h-[540px] lg:min-h-[540px] overflow-hidden relative rounded-2xl"
      data-name="Container"
    >
      <div
        className="absolute bg-center bg-cover bg-no-repeat inset-0 rounded-2xl"
        style={{ backgroundImage: `url('${facilityItem.image}')` }}
      />
      <Container6 
        facilityItem={facilityItem} 
        currentIndex={currentIndex}
        totalImages={totalImages}
        onImageSelect={onImageSelect}
      />
      
      {/* 이미지 네비게이션 버튼들 - 데스크톱에서만 표시, 이미지 끝에 반쯤 걸치게 배치하되 1280px 컨테이너 내에서만 */}
      <div className="hidden lg:block">
        <button
          onClick={onPrevImage}
          className="absolute -left-[30px] top-1/2 -translate-y-1/2 z-30 w-[60px] h-[60px] bg-white border border-[#999999] rounded-full flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform shadow-lg"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <button
          onClick={onNextImage}
          className="absolute -right-[30px] top-1/2 -translate-y-1/2 z-30 w-[60px] h-[60px] bg-white border border-[#999999] rounded-full flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform shadow-lg"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
}

// Facility Info Overlay - facilityData 인터페이스와 일치하도록 업데이트
function Container6({ 
  facilityItem,
  currentIndex,
  totalImages,
  onImageSelect
}: { 
  facilityItem: {
    id: string;
    title: string;
    description: string;
    category: 'physical' | 'digital' | 'facilities' | 'all';
    image: string;
    features?: string[];
  };
  currentIndex: number;
  totalImages: number;
  onImageSelect: (index: number) => void;
}) {
  return (
    <div
      className="absolute inset-0 bg-gradient-to-b from-transparent from-30% via-black/20 via-70% to-black/80 box-border content-stretch flex flex-col gap-2 items-start justify-end leading-[0] not-italic pb-[24px] sm:pb-[32px] lg:pb-[40px] px-[24px] sm:px-[32px] lg:px-[40px] rounded-2xl text-[#ffffff] text-left"
      data-name="Container"
    >
      <div className="font-paperlogy font-bold relative shrink-0 text-[24px] sm:text-[26px] lg:text-[28px] tracking-[-0.56px] w-full">
        <p className="block leading-[normal] font-bold text-shadow-lg drop-shadow-lg">{facilityItem.title}</p>
      </div>
      <div className="flex items-end justify-between w-full gap-[min(16px,_3vw)]">
        <div className="font-paperlogy font-normal relative shrink-0 text-[14px] sm:text-[15px] lg:text-[16px] tracking-[-0.32px] flex-1">
          <p className="block leading-[normal] mb-2 drop-shadow-md">
            {facilityItem.description}
          </p>
          {facilityItem.features && facilityItem.features.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-2">
              {facilityItem.features.slice(0, 3).map((feature, index) => (
                <span key={index} className="text-[11px] sm:text-[12px] text-white/90 drop-shadow-sm">
                  #{feature}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="flex gap-[6px] sm:gap-[8px] items-center bg-black/20 backdrop-blur-sm rounded-full px-[10px] sm:px-[12px] py-[6px] sm:py-[8px] shrink-0 ml-[12px] sm:ml-[16px]">
          {Array.from({ length: totalImages }, (_, index) => (
            <button
              key={index}
              onClick={() => onImageSelect(index)}
              className={`w-[6px] sm:w-[8px] h-[6px] sm:h-[8px] rounded-full transition-all duration-300 cursor-pointer hover:scale-125 ${
                index === currentIndex 
                  ? 'bg-white w-[20px] sm:w-[24px]' 
                  : 'bg-white/50 hover:bg-white/70'
              }`}
              aria-label={`${index + 1}번째 이미지로 이동`}
            />
          ))}
          <span className="ml-[6px] sm:ml-[8px] text-[12px] sm:text-[14px] text-white/90 font-medium drop-shadow-sm">
            {currentIndex + 1} / {totalImages}
          </span>
        </div>
      </div>
    </div>
  );
}

function Container7({ 
  facilityItem, 
  onPrevImage, 
  onNextImage, 
  currentIndex, 
  totalImages,
  onImageSelect
}: { 
  facilityItem: {
    id: string;
    title: string;
    description: string;
    category: 'physical' | 'digital' | 'facilities' | 'all';
    image: string;
    features?: string[];
  };
  onPrevImage: () => void;
  onNextImage: () => void;
  currentIndex: number;
  totalImages: number;
  onImageSelect: (index: number) => void;
}) {
  return (
    <div
      className="box-border content-stretch flex flex-col lg:flex-row gap-6 h-auto items-center justify-start overflow-visible p-0 relative shrink-0 w-full px-[max(20px,_calc((100vw_-_1280px)_/_2))]"
      data-name="Container"
    >
      <div className="w-[min(1280px,_calc(100vw_-_40px))] mx-auto flex flex-col lg:flex-row gap-6 items-center justify-start overflow-visible relative">
        <Container5 
          facilityItem={facilityItem}
          currentIndex={currentIndex}
          totalImages={totalImages}
          onImageSelect={onImageSelect}
          onPrevImage={onPrevImage}
          onNextImage={onNextImage}
        />
      </div>
    </div>
  );
}

// Mobile Navigation for Facilities
function FacilityMobileNavigation({ 
  onPrevImage, 
  onNextImage, 
  currentIndex, 
  totalImages,
  onImageSelect
}: { 
  onPrevImage: () => void;
  onNextImage: () => void;
  currentIndex: number;
  totalImages: number;
  onImageSelect: (index: number) => void;
}) {
  return (
    <div className="lg:hidden flex items-center justify-center gap-4 mt-4">
      <button 
        onClick={onPrevImage}
        className="w-12 h-12 rounded-full border border-[#999999] bg-white flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      
      <div className="flex gap-2 items-center px-4">
        {Array.from({ length: totalImages }, (_, index) => (
          <button
            key={index}
            onClick={() => onImageSelect(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer hover:scale-125 ${
              index === currentIndex 
                ? 'bg-[#cacc2f] w-6' 
                : 'bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`${index + 1}번째 이미지로 이동`}
          />
        ))}
      </div>
      
      <button 
        onClick={onNextImage}
        className="w-12 h-12 rounded-full border border-[#999999] bg-white flex items-center justify-center hover:border-[#cacc2f] hover:bg-[#f8f8f8] hover:scale-110 transition-all duration-300 ease-in-out transform"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="#999999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}

// More Button for Facilities
function ButtonContainer4({ onClick }: { onClick?: () => void }) {
  return (
    <button
      onClick={onClick}
      className="bg-[#cacc2f] hover:bg-[#b8bb28] box-border content-stretch flex flex-row gap-4 items-center justify-center px-6 py-4 relative rounded-[100px] shrink-0 w-60 cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg transform"
      data-name="Button Container"
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[20px] text-left text-neutral-950 text-nowrap tracking-[-0.4px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          시설 더보기
        </p>
      </div>
      <div className="flex h-[14px] items-center justify-center relative shrink-0 w-[14px]">
        <div className="flex-none rotate-[90deg]">
          <div className="relative size-3.5">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 14 11"
              >
                <path
                  d={svgPaths.p3ed61000}
                  fill="var(--fill-0, #333333)"
                  id="Polygon 1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}

// 메인화면용 시설 데이터 제한 함수 - 각 카테고리별로 3개씩 제한
function getMainPageFacilityData() {
  const digitalFacilities = facilityData.filter(item => item.category === 'digital').slice(0, 3); // 디지털 콘텐츠 상위 3개
  const physicalFacilities = facilityData.filter(item => item.category === 'physical').slice(0, 3); // 놀이시설 상위 3개
  const facilitiesFacilities = facilityData.filter(item => item.category === 'facilities').slice(0, 3); // 부대시설 상위 3개
  
  return {
    digital: digitalFacilities,
    physical: physicalFacilities,
    facilities: facilitiesFacilities
  };
}

// Facility Section - 메인화면용 제한된 데이터 사용
function Section2({ onFacilityClick }: { onFacilityClick?: () => void }) {
  const [activeTab, setActiveTab] = useState('digital');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // 메인화면용 제한된 시설 데이터
  const mainFacilityData = getMainPageFacilityData();
  
  // 현재 탭에 따른 시설 데이터 선택
  const currentFacilityData = activeTab === 'digital' 
    ? mainFacilityData.digital 
    : activeTab === 'physical' 
    ? mainFacilityData.physical 
    : mainFacilityData.facilities;
  const maxImageIndex = Math.max(0, currentFacilityData.length - 1);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev < maxImageIndex ? prev + 1 : 0));
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : maxImageIndex));
  };

  const selectImage = (index: number) => {
    setCurrentImageIndex(index);
  };

  // 현재 선택된 시설 데이터가 없는 경우 기본값 제공
  const currentFacility = currentFacilityData[currentImageIndex] || {
    id: 'default',
    title: '준비중',
    description: '곧 멋진 시설을 만나보실 수 있어요',
    category: activeTab as 'physical' | 'digital' | 'facilities' | 'all',
    image: '',
    features: []
  };

  return (
    <div
      className="box-border content-stretch flex flex-col gap-20 items-start justify-start pb-0 pt-20 px-0 relative shrink-0 w-full"
      data-name="Section"
    >
      <div className="box-border content-stretch flex flex-col gap-6 items-start justify-start p-0 relative shrink-0 w-full">
        <Container4 activeTab={activeTab} onTabChange={handleTabChange} />
        {currentFacilityData.length > 0 && (
          <>
            <Container7 
              facilityItem={currentFacility} 
              onPrevImage={prevImage}
              onNextImage={nextImage}
              currentIndex={currentImageIndex}
              totalImages={currentFacilityData.length}
              onImageSelect={selectImage}
            />
            <FacilityMobileNavigation 
              onPrevImage={prevImage}
              onNextImage={nextImage}
              currentIndex={currentImageIndex}
              totalImages={currentFacilityData.length}
              onImageSelect={selectImage}
            />
          </>
        )}
      </div>
      <div className="flex justify-center w-full">
        <ButtonContainer4 onClick={onFacilityClick} />
      </div>
    </div>
  );
}

// Background Decorative Element
function Background() {
  return (
    <div
      className="absolute h-[min(934px,_60vh)] bottom-[-50px] translate-x-[-50%] w-[min(4253.22px,_400vw)] opacity-50 z-0"
      data-name="Background"
      style={{ left: "calc(50% + 0.305px)" }}
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 2127 467"
      >
        <g id="Background">
          <path
            d={svgPaths.p2c0b5900}
            fill="url(#paint0_linear_1_450)"
            id="Rectangle 16"
          />
          <circle
            cx="450"
            cy="80"
            fill="url(#paint1_linear_1_450)"
            id="Ellipse 8"
            r="20"
            style={{ 
              transformOrigin: '450px 80px',
              animation: 'float-gentle 6s ease-in-out infinite',
              animationDelay: '0s'
            }}
          />
          <circle
            cx="1200"
            cy="240"
            fill="var(--fill-0, #D4A533)"
            fillOpacity="0.4"
            id="Ellipse 9"
            r="6"
            style={{ 
              transformOrigin: '1200px 240px',
              animation: 'float-gentle 8s ease-in-out infinite',
              animationDelay: '2s'
            }}
          />
          <circle
            cx="800"
            cy="300"
            fill="url(#paint4_linear_1_450)"
            id="Ellipse 11"
            r="14"
            style={{ 
              transformOrigin: '800px 300px',
              animation: 'float-gentle 7s ease-in-out infinite',
              animationDelay: '1s'
            }}
          />
          <circle
            cx="1400"
            cy="70"
            fill="var(--fill-0, #FFD844)"
            fillOpacity="0.6"
            id="Ellipse 16"
            r="10"
            style={{ 
              transformOrigin: '1400px 70px',
              animation: 'float-gentle 9s ease-in-out infinite',
              animationDelay: '3s'
            }}
          />
          <circle
            cx="1300"
            cy="100"
            fill="url(#paint5_linear_1_450)"
            id="Ellipse 17"
            r="18"
            style={{ 
              transformOrigin: '1300px 100px',
              animation: 'float-gentle 5.5s ease-in-out infinite',
              animationDelay: '0.5s'
            }}
          />
          <circle
            cx="600"
            cy="180"
            fill="var(--fill-0, #D4A533)"
            fillOpacity="0.3"
            id="Ellipse 19"
            r="8"
            style={{ 
              transformOrigin: '600px 180px',
              animation: 'float-gentle 7.5s ease-in-out infinite',
              animationDelay: '4s'
            }}
          />
          <circle
            cx="1100"
            cy="150"
            fill="url(#paint2_linear_1_450)"
            fillOpacity="0.5"
            id="Ellipse 20"
            r="16"
            style={{ 
              transformOrigin: '1100px 150px',
              animation: 'float-gentle 6.5s ease-in-out infinite',
              animationDelay: '1.5s'
            }}
          />
          <circle
            cx="1500"
            cy="280"
            fill="var(--fill-0, #FFD844)"
            fillOpacity="0.4"
            id="Ellipse 21"
            r="12"
            style={{ 
              transformOrigin: '1500px 280px',
              animation: 'float-gentle 8.5s ease-in-out infinite',
              animationDelay: '2.8s'
            }}
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_1_450"
            x1="1063.3"
            x2="1063.3"
            y1="132"
            y2="467"
          >
            <stop stopColor="#FFD844" stopOpacity="0" />
            <stop offset="1" stopColor="#D4A533" stopOpacity="0.8" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_1_450"
            x1="450"
            x2="450"
            y1="60"
            y2="100"
          >
            <stop stopColor="#D4A533" stopOpacity="0.8" />
            <stop offset="1" stopColor="#FFD844" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint2_linear_1_450"
            x1="1100"
            x2="1100"
            y1="134"
            y2="166"
          >
            <stop stopColor="#D4A533" stopOpacity="0.8" />
            <stop offset="1" stopColor="#FFD844" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint3_linear_1_450"
            x1="1363"
            x2="1363"
            y1="248.599"
            y2="267"
          >
            <stop stopColor="#D4A533" stopOpacity="0.8" />
            <stop offset="1" stopColor="#FFD844" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint4_linear_1_450"
            x1="800"
            x2="800"
            y1="286"
            y2="314"
          >
            <stop stopColor="#D4A533" stopOpacity="0.8" />
            <stop offset="1" stopColor="#FFD844" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint5_linear_1_450"
            x1="1300"
            x2="1300"
            y1="82"
            y2="118"
          >
            <stop stopColor="#D4A533" stopOpacity="0.8" />
            <stop offset="1" stopColor="#FFD844" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint6_linear_1_450"
            x1="1957"
            x2="1957"
            y1="160.199"
            y2="197"
          >
            <stop stopColor="#D4A533" stopOpacity="0.8" />
            <stop offset="1" stopColor="#FFD844" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export function FacilitySection({ onFacilityClick }: { onFacilityClick?: () => void }) {
  return (
    <div
      id="facility-section"
      className="bg-[#ffffff] relative shrink-0 w-full"
      data-name="Main Container"
    >
      <div className="overflow-x-clip overflow-y-visible relative size-full">
        <Background />
        <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start w-full py-[120px] relative z-10">
          <Section2 onFacilityClick={onFacilityClick} />
        </div>
      </div>
    </div>
  );
}